import { createSlotRecipe } from './runtime';

const avatarConfig = {"name":"avatar","slots":["root","image","fallback"],"defaultVariants":{"size":"md"},"variantMap":{"size":["2xl","lg","md","sm","xl","xs"]}}

export const avatar = /* @__PURE__ */ createSlotRecipe(avatarConfig)